import React from "react"

// styles
import Styles from "./kycStatusBadge.module.css"

// icons
import { ReactComponent as CheckmarkIcon } from "../../assets/icons/imported/checkmark.svg"

function KYCStatusBadge({
  status // not-verified - pending - verified
}) {
  if (status === "verified")
    return (
      <div className={`${Styles.container} ${Styles.verified}`}>
        <CheckmarkIcon
          className={Styles.checkmarkIcon}
          color="var(--primary-color)"
        />
        <span>Verified</span>
      </div>
    )

  if (status === "pending" || status === "sdk_pending" || status === "sdk_started")
    return (
      <div className={`${Styles.container} ${Styles.pending}`}>
        <span>!</span>
        <span>{status === "sdk_started" ? "In Progress" : "Pending"}</span>
      </div>
    )

  if (status === "sdk_completed")
    return (
      <div className={`${Styles.container} ${Styles.pending}`}>
        <span>!</span>
        <span>Awaiting Approval</span>
      </div>
    )

  if (status === "not-verified" || status === "not_started" || status === "sdk_not_started")
    return (
      <div className={`${Styles.container} ${Styles.notVerified}`}>
        Not verified
      </div>
    )

  if (status === "rejected")
    return (
      <div className={`${Styles.container} ${Styles.notVerified}`}>
        Rejected
      </div>
    )

  if (!status) return null
}

export default KYCStatusBadge
